module.exports = __webpack_public_path__ + "static/media/logo135.8d3f4cee.png";